module.exports = __webpack_public_path__ + "static/img/anli.d83bfa5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/anli.jpg
// module id = zq4Q
// module chunks = 1